import { Component } from '@angular/core';

@Component({
  selector: 'app-magic2026',
  templateUrl: './magic2026.component.html',
  styleUrl: './magic2026.component.css'
})
export class Magic2026Component {

}
